import React from 'react'
import { Redirect, IndexRedirect } from 'react-router'

export const Path = '/customize'

export const Routes = [
  <IndexRedirect key="routes-customize-index" to="/settings/widget" />,
  <Redirect key="routes-customize-hours" from="hours" to="/settings2/widget/hours-and-targeting" />,
  <Redirect key="routes-customize-style" from="style" to="/settings2/widget/design" />,
  <Redirect key="routes-customize-online" from="online" to="/settings/widget" />,
  <Redirect key="routes-customize-offline" from="offline" to="/settings/widget" />
]



// WEBPACK FOOTER //
// ./src/scripts/app/routes/CustomizeRoutes.js